/// <reference types="node" />

import {
    ENVIRONMENT
// @ts-expect-error: module @env not fully typed
} from "@env";
import actions from "../actions";

export let SERVER_ADDRESS = process.env.SERVER_ADDRESS ? process.env.SERVER_ADDRESS : "https://api.gencmusiadkonya.org";

export const SERVER_ADDRESS_VERSION_JSON = ENVIRONMENT === "development" ? "" : "https://api.gencmusiadkonya.org";

export let SHARE_ADRESS = ENVIRONMENT === "production" ? "https://app.gencmusiadkonya.org" : "https://share-dev.gencmusiadkonya.org";

export let SERVER_ADDRESS_STORAGE = process.env.REACT_APP_SERVER_ADDRESS_STORAGE
    ? process.env.REACT_APP_SERVER_ADDRESS_STORAGE
    : "https://storage.gencmusiadkonya.org";
if (!process.env.SERVER_ADDRESS) {
    if (ENVIRONMENT === "development") {
        SERVER_ADDRESS = "http://192.168.0.10:81";
        SERVER_ADDRESS_STORAGE = "http://192.168.0.10:8484";
        SHARE_ADRESS = "http://share-dev.gencmusiadkonya.org";
    }

    if (ENVIRONMENT === "production") {
        SERVER_ADDRESS = "https://api.gencmusiadkonya.org";
        SERVER_ADDRESS_STORAGE = "https://storage.gencmusiadkonya.org";
        SHARE_ADRESS = "https://app.gencmusiadkonya.org";
    }

    if (ENVIRONMENT === "custom") {
        console.log("ns", ENVIRONMENT);
        SERVER_ADDRESS = "http://192.168.0.10:81";
        SERVER_ADDRESS_STORAGE = "http://192.168.0.10:8484";
    }
}

console.log("[restAPI] Initialized SERVER_ADDRESS:", SERVER_ADDRESS, "ENVIRONMENT:", ENVIRONMENT);

export const SERVICE_EVENT_TYPES = {
    "REFRESH_TOKEN": "REFRESH_TOKEN",
    "GO_TO_LOGOUT": "GO_TO_LOGOUT"
};

export const SERVICE_CONFIGS: Record<keyof typeof actions, {
    isWorkedWithQueue: boolean;
}> = {
    GetInitialConfigs: {
        isWorkedWithQueue: false
    },
    Login: {
        isWorkedWithQueue: false
    },
    RefreshToken: {
        isWorkedWithQueue: false
    },
    SetForgottenPassword:{
        isWorkedWithQueue: true
    },
    StartForgetPassword:{
        isWorkedWithQueue: false
    },
    CheckForgotPWCode:{
        isWorkedWithQueue: false
    },
    Me: {
        isWorkedWithQueue: true
    },
    ChangePassword: {
        isWorkedWithQueue: true
    },
    StartMailVerify: {
        isWorkedWithQueue: true
    },
    FinishMailVerify: {
        isWorkedWithQueue: true
    },
    GetMemberProfile: {
        isWorkedWithQueue: true
    },
    GetCompanyProfile: {
        isWorkedWithQueue: true
    },
    GetSearch: {
        isWorkedWithQueue: true
    },
    NewCommercialOpportunity: {
        isWorkedWithQueue: true
    },
    EditCommercialOpportunity: {
        isWorkedWithQueue: true
    },
    RemoveCommercialOpportunity: {
        isWorkedWithQueue: true
    },
    GetMyCompanies: {
        isWorkedWithQueue: true
    },
    GetCommercialOpportunies: {
        isWorkedWithQueue: true
    },
    GetMyOpportunities: {
        isWorkedWithQueue: true
    },
    GetMyNotifications: {
        isWorkedWithQueue: true
    },
    DeleteNotification: {
        isWorkedWithQueue: true
    },
    SendProfileUpdateRequest: {
        isWorkedWithQueue: true
    },
    CancelProfileUpdateRequest: {
        isWorkedWithQueue: true
    },
    GetProfileUpdateRequest: {
        isWorkedWithQueue: true
    },
    EditCompanyRequest: {
        isWorkedWithQueue: true
    },
    CancelRequestForUpdateCompany: {
        isWorkedWithQueue: true
    },
    DeleteCompanyRequest: {
        isWorkedWithQueue: true
    },
    GetCompanyUpdateRequests: {
        isWorkedWithQueue: true
    },
    CreateCompanyRequest: {
        isWorkedWithQueue: true
    },
    UpdateRequestForEditCompany: {
        isWorkedWithQueue: true
    },
    GetUnreadCount: {
        isWorkedWithQueue: true
    },
    MarkAllAsRead: {
        isWorkedWithQueue: true
    },
    GetMyProfile: {
        isWorkedWithQueue: true
    },
    MarkAsRead: {
        isWorkedWithQueue: true
    },
    GetPositions: {
        isWorkedWithQueue: true
    },
    GetCompanies: {
        isWorkedWithQueue: false
    },
    CompanySearch: {
        isWorkedWithQueue: true
    },
    Logout: {
        isWorkedWithQueue: true
    },
    GetBoardOfDirectors: {
        isWorkedWithQueue: true
    },
    GetFeaturedData:{
        isWorkedWithQueue: true
    },
    GetAnnouncements:{
        isWorkedWithQueue: true
    },
    GetNews:{
        isWorkedWithQueue: true
    },
    GetAboutPresident: {
        isWorkedWithQueue: true
    },
    GetMyCompanyDetail: {
        isWorkedWithQueue: true
    },
    GetSectors: {
        isWorkedWithQueue: true
    },
    DeleteMyAccount: {
        isWorkedWithQueue: true
    },
    GetAboutUs: {
        isWorkedWithQueue: true
    },
    GetPrivacyPolicy: {
        isWorkedWithQueue: true
    },
    GetMemberPolicy: {
        isWorkedWithQueue: true
    },
    GetKVKK: {
        isWorkedWithQueue: true
    },
    GetOldPresidents: {
        isWorkedWithQueue: true
    },
    GetEvents: {
        isWorkedWithQueue: true
    },
    GetEventsWithoutAuth: {
        isWorkedWithQueue: false
    },
    GetEventDetail: {
        isWorkedWithQueue: true
    },
    GetEventDetailWithoutAuth: {
        isWorkedWithQueue: false
    },
    GetUploadTokenForFormPhotoWithoutAuth: {
        isWorkedWithQueue: false
    },
    GetUploadTokenForFormPhoto: {
        isWorkedWithQueue: false
    },
    GetEventApplicationForm: {
        isWorkedWithQueue: true
    },
    GetEventApplicationFormWihoutAuth: {
        isWorkedWithQueue: false
    },
    EventApplication: {
        isWorkedWithQueue: true
    },
    EventApplicationWithoutAuth: {
        isWorkedWithQueue: false
    },
    GetNewsCategories: {
        isWorkedWithQueue: false
    },
    GetNewsDetail: {
        isWorkedWithQueue: false
    },
    GetAnnouncementDetail: {
        isWorkedWithQueue: false
    },
    UploadProfilePhoto: {
        isWorkedWithQueue: true
    },
    UpdateCompanyPhoto: {
        isWorkedWithQueue: true
    },
    CreateCompanyPhoto: {
        isWorkedWithQueue: true
    },
    CampaignCoverPhotoUpdate: {
        isWorkedWithQueue: true
    },
    SendContactForm: {
        isWorkedWithQueue: false
    },
    SendContactFormWithAuth:  {
        isWorkedWithQueue: true
    },
    GetThreetTokenForMembers: {
        isWorkedWithQueue: true
    },
    GetThreetTokenForGuests: {
        isWorkedWithQueue: false
    },
    GetParticipantActiveState: {
        isWorkedWithQueue: false
    },
    GetMemberTableInfo: {
        isWorkedWithQueue: false
    },
    GetGuestTableInfo: {
        isWorkedWithQueue: false
    },
    GetThreetTokenWithoutCode: {
        isWorkedWithQueue: true
    }
};
